// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

.main-content {
  flex: 1 1;
  margin-left: 250px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
}

.App.nav-collapsed .main-content {
  margin-left: 80px;
}

.App-header {
  background-color: #282c34;
  padding: 20px;
  color: white;
}

.header-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.header-content h1 {
  margin: 0;
  flex: 1 1;
  text-align: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.mobile-nav-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.mobile-nav-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.mobile-nav-toggle:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.header-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.user-info {
  color: #ccc;
  font-size: 14px;
  font-weight: 500;
}

.view-restored-message {
  background-color: rgba(33, 150, 243, 0.9);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  animation: slideInFade 3s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-transform: capitalize;
}

@keyframes slideInFade {
  0% { opacity: 0; transform: translateY(-10px); }
  15% { opacity: 1; transform: translateY(0); }
  85% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
}

.logo {
  height: 80px;
  width: auto;
  object-fit: contain;
}

.App-header h1 {
  margin: 0;
  font-size: 2rem;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
  
  .header-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
  }
  
  .header-content h1 {
    font-size: 18px;
    flex: 1 1;
    text-align: center;
    margin: 0 10px;
  }
  
  .header-left {
    flex-shrink: 0;
  }
  
  .header-right {
    flex-shrink: 0;
    gap: 10px;
  }
  
  .mobile-nav-toggle {
    display: block;
  }
  
  .logo {
    height: 40px;
  }
  
  .user-info {
    display: none; /* Hide user info on mobile to save space */
  }
  
  .view-restored-message {
    display: none; /* Hide view restored message on mobile */
  }
  
  .App-header h1 {
    font-size: 1.5rem;
    margin: 0;
  }
  
  .App-header {
    padding: 15px;
  }
  
  main {
    padding: 15px;
  }
}

main {
  flex: 1 1;
  padding: 20px;
  background-color: #f8f9fa;
}

.error-message {
  background-color: #ffdddd;
  color: #990000;
  padding: 15px;
  border-radius: 5px;
  margin: 20px 0;
}

/* Authentication loading states */
.auth-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.auth-loading p,
.loading-container p {
  color: white;
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}

.loading-container p {
  color: #666;
}

/* Access denied styling */
.access-denied {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  text-align: center;
  padding: 40px;
}

.access-denied h2 {
  color: #dc3545;
  margin-bottom: 15px;
}

.access-denied p {
  color: #666;
  margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAO;IACP,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa,EAAE,2CAA2C;EAC5D;;EAEA;IACE,aAAa,EAAE,yCAAyC;EAC1D;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf","sourcesContent":[".App {\n  display: flex;\n  min-height: 100vh;\n  font-family: Arial, sans-serif;\n}\n\n.main-content {\n  flex: 1;\n  margin-left: 250px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  transition: margin-left 0.3s ease;\n}\n\n.App.nav-collapsed .main-content {\n  margin-left: 80px;\n}\n\n.App-header {\n  background-color: #282c34;\n  padding: 20px;\n  color: white;\n}\n\n.header-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.header-content h1 {\n  margin: 0;\n  flex: 1;\n  text-align: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.mobile-nav-toggle {\n  display: none;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.mobile-nav-toggle:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.mobile-nav-toggle:focus {\n  outline: 2px solid rgba(255, 255, 255, 0.5);\n  outline-offset: 2px;\n}\n\n.header-right {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.user-info {\n  color: #ccc;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.view-restored-message {\n  background-color: rgba(33, 150, 243, 0.9);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  animation: slideInFade 3s ease-in-out;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  text-transform: capitalize;\n}\n\n@keyframes slideInFade {\n  0% { opacity: 0; transform: translateY(-10px); }\n  15% { opacity: 1; transform: translateY(0); }\n  85% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-10px); }\n}\n\n.logo {\n  height: 80px;\n  width: auto;\n  object-fit: contain;\n}\n\n.App-header h1 {\n  margin: 0;\n  font-size: 2rem;\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n  }\n  \n  .header-content {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 0 10px;\n  }\n  \n  .header-content h1 {\n    font-size: 18px;\n    flex: 1;\n    text-align: center;\n    margin: 0 10px;\n  }\n  \n  .header-left {\n    flex-shrink: 0;\n  }\n  \n  .header-right {\n    flex-shrink: 0;\n    gap: 10px;\n  }\n  \n  .mobile-nav-toggle {\n    display: block;\n  }\n  \n  .logo {\n    height: 40px;\n  }\n  \n  .user-info {\n    display: none; /* Hide user info on mobile to save space */\n  }\n  \n  .view-restored-message {\n    display: none; /* Hide view restored message on mobile */\n  }\n  \n  .App-header h1 {\n    font-size: 1.5rem;\n    margin: 0;\n  }\n  \n  .App-header {\n    padding: 15px;\n  }\n  \n  main {\n    padding: 15px;\n  }\n}\n\nmain {\n  flex: 1;\n  padding: 20px;\n  background-color: #f8f9fa;\n}\n\n.error-message {\n  background-color: #ffdddd;\n  color: #990000;\n  padding: 15px;\n  border-radius: 5px;\n  margin: 20px 0;\n}\n\n/* Authentication loading states */\n.auth-loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.auth-loading p,\n.loading-container p {\n  color: white;\n  font-size: 16px;\n  margin: 0;\n  font-weight: 500;\n}\n\n.loading-container p {\n  color: #666;\n}\n\n/* Access denied styling */\n.access-denied {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 50vh;\n  text-align: center;\n  padding: 40px;\n}\n\n.access-denied h2 {\n  color: #dc3545;\n  margin-bottom: 15px;\n}\n\n.access-denied p {\n  color: #666;\n  margin: 5px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
